import { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

// ----------------------------------------------------------------------

const injectGoogleMapsScript = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  // Prevent duplicate script injection
  if (document.getElementById('google-maps-script')) return;

  const script = document.createElement('script');
  script.id = 'google-maps-script';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async&callback=initMap`;
  script.async = true;

  document.head.appendChild(script);
};

window.initMap = function() {
  // This can be empty, or you can set a flag/state here if needed
};

const Root = () => {
  // useEffect(() => {
  //   injectGoogleMapsScript();
  // }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <LocalizationProvider dateAdapter={AdapterDateFns}>
  <HelmetProvider>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </HelmetProvider>
  </LocalizationProvider>
);
